<template>
  <v-card class="pa-4">
    <v-card-title>{{ $t('title') }}</v-card-title>
    <v-card-text>
      <v-form v-model="form.i18n.valid">
        <div class="title"></div>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
                prepend-icon="mdi-web"
                v-model="form.i18n.fields.country"
                :items="$locale.countriesItems"
                hide-no-data
                hide-selected
                :label="$t('geolocalisation-label')"
                persistent-hint
                :hint="$t('geolocalisation-hint')"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
                prepend-icon="mdi-translate"
                v-model="form.i18n.fields.language"
                :items="$locale.translatedLanguagesItems"
                hide-no-data
                hide-selected
                :label="$t('language-label')"
                persistent-hint
                :hint="$t('language-hint')"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
                prepend-icon="mdi-map-clock-outline"
                v-model="form.i18n.fields.timezone"
                :items="$locale.timezonesItems"
                hide-no-data
                hide-selected
                :label="$t('timezone-label')"
                persistent-hint
                :hint="$t('timezone-hint')"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn class="primary" :loading="form.i18n.loading" @click="submitI18n">{{ $t('actions.save') }}</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'Locales',
  data() {
    return {
      form: {
        i18n: {
          valid: false,
          loading: false,
          fields: {
            country: null,
            language: null,
            timezone: null
          },
          rules: {
            country: [v => !!v || this.$t('country-empty')],
            language: [v => !!v || this.$t('language-empty')],
            timezone: [v => !!v || this.$t('timezone-empty')],
          }
        }
      }
    }
  },
  methods: {
    submitI18n() {
      this.form.i18n.loading = true
      this.$account.update(this.form.i18n.fields)
          .then(() => {
            this.form.i18n.loading = false
            this.$ui.success(this.$t('save-changes'))
          })
          .catch(() => {
            this.form.i18n.loading = false
          })
    }
  },
  mounted () {
    const user = this.$account.current

    // i18n
    this.form.i18n.fields.country = user.country
    this.form.i18n.fields.language = user.language
    this.form.i18n.fields.timezone = user.timezone
  }
}


</script>


<i18n>
{
	"en": {
		"country-empty": "Your country is required.",
		"geolocalisation-hint": "Determines the geolocation of the search engine. For example google.fr for France.",
		"geolocalisation-label": "Geolocation",
		"language-empty": "Your language is required.",
		"language-hint": "Used for the translation of the application.",
		"language-label": "Language",
		"save-changes": "Changes saved.",
		"timezone-empty": "Your time zone is required.",
		"timezone-hint": "Determines the update time of your positions, and modifies the dates/times of the interface.",
		"timezone-label": "Time zone",
		"title": "Geolocation & Translation"
	},
	"es": {
		"country-empty": "Su país es obligatorio.",
		"geolocalisation-hint": "Determina la geolocalización del motor de búsqueda. Por ejemplo, google.fr para Francia.",
		"geolocalisation-label": "Geolocalización",
		"language-empty": "Su idioma es obligatorio.",
		"language-hint": "Se utiliza para la traducción de la aplicación.",
		"language-label": "Lengua",
		"save-changes": "Cambios guardados.",
		"timezone-empty": "Se requiere su zona horaria.",
		"timezone-hint": "Determina el tiempo de actualización de sus posiciones y modifica las fechas/horas de la interfaz.",
		"timezone-label": "Huso horario",
		"title": "Geolocalización y Traducción"
	},
	"fr": {
		"country-empty": "Votre pays est requis.",
		"geolocalisation-hint": "Détermine la géolocalisation du moteur de recherche. Par exemple google.fr pour la France.",
		"geolocalisation-label": "Géolocalisation",
		"language-empty": "Votre langue est requise.",
		"language-hint": "Utilisé pour la traduction de l'application.",
		"language-label": "Langue",
		"save-changes": "Modifications enregistrées.",
		"timezone-empty": "Votre fuseau horaire est requis.",
		"timezone-hint": "Détermine l'heure d'actualisation de vos positions, et modifie les dates/heures de l'interface.",
		"timezone-label": "Fuseau horaire",
		"title": "Géolocalisation & Traduction"
	},
	"it": {
		"country-empty": "Il tuo paese è obbligatorio.",
		"geolocalisation-hint": "Determina la geolocalizzazione del motore di ricerca. Ad esempio google.it per l'Italia.",
		"geolocalisation-label": "Geolocalizzazione",
		"language-empty": "La tua lingua è obbligatoria.",
		"language-hint": "Usato per la traduzione dell'applicazione.",
		"language-label": "Lingua",
		"save-changes": "Modifiche salvate.",
		"timezone-empty": "Il tuo fuso orario è obbligatorio.",
		"timezone-hint": "Determina l'orario di aggiornamento delle tue posizioni e modifica le date/orari dell'interfaccia.",
		"timezone-label": "Fuso orario",
		"title": "Geolocalizzazione & Traduzione"
	},
	"pt": {
		"country-empty": "O seu país é obrigatório.",
		"geolocalisation-hint": "Determina a geolocalização do motor de pesquisa. Por exemplo google.pt para Portugal.",
		"geolocalisation-label": "Geolocalização",
		"language-empty": "O seu idioma é obrigatório.",
		"language-hint": "Utilizado para a tradução da aplicação.",
		"language-label": "Idioma",
		"save-changes": "Alterações guardadas.",
		"timezone-empty": "O seu fuso horário é obrigatório.",
		"timezone-hint": "Determina a hora de atualização das suas posições e modifica as datas/horas da interface.",
		"timezone-label": "Fuso horário",
		"title": "Geolocalização & Tradução"
	},
	"pl": {
		"country-empty": "Twój kraj jest wymagany.",
		"geolocalisation-hint": "Określa geolokalizację wyszukiwarki. Na przykład google.pl dla Polski.",
		"geolocalisation-label": "Geolokalizacja",
		"language-empty": "Twój język jest wymagany.",
		"language-hint": "Używany do tłumaczenia aplikacji.",
		"language-label": "Język",
		"save-changes": "Zmiany zostały zapisane.",
		"timezone-empty": "Twoja strefa czasowa jest wymagana.",
		"timezone-hint": "Określa czas aktualizacji Twoich pozycji i modyfikuje daty/godziny interfejsu.",
		"timezone-label": "Strefa czasowa",
		"title": "Geolokalizacja i Tłumaczenie"
	}
}
</i18n>